import { render, staticRenderFns } from "./adhocAllocation.vue?vue&type=template&id=58fdbdee"
import script from "./adhocAllocation.vue?vue&type=script&lang=js"
export * from "./adhocAllocation.vue?vue&type=script&lang=js"
import style0 from "./adhocAllocation.vue?vue&type=style&index=0&id=58fdbdee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports